<template>
  <div class="row">
    <div class="col-12">
      <div class="card card-sales-rank">
        <div class="card-body" style="min-height: 200px">
          <div v-if="!isLoading" class="d-flex justify-content-between align-items-center mb-3">
            <button
                class="btn btn-icon text-white"
                :class="ranks.show_previous_month_button ? 'btn-navigation' : 'btn-secondary'"
                :disabled="!ranks.show_previous_month_button"
                @click="fetchRank('previous', ranks.show_previous_month_button)"
            >
              <i class="fa fa-angle-left"></i>
            </button>

            <h4 class="card-title mb-0">
              {{ headline }}: Top performer bonus On {{ formattedPeriod(currentMonth, currentYear, true) }}
            </h4>

            <button
                class="btn btn-icon text-white"
                :class="ranks.show_next_month_button ? 'btn-navigation' : 'btn-secondary'"
                :disabled="!ranks.show_next_month_button"
                @click="fetchRank('next', ranks.show_next_month_button)"
            >
              <i class="fa fa-angle-right"></i>
            </button>
          </div>

          <div v-if="isLoading" class="text-center">
            <span>Loading...</span>
          </div>

          <div v-else>
            <table class="table table-sales-rank">
              <thead>
              <tr>
                <th></th>
                <th class="expand-column" v-if="dashboardType === 'team_manager'"></th>
                <th v-else class="d-none"></th>
                <th></th>
                <th>{{ headline }} Name</th>
                <th class="text-center">Points</th>
                <th class="text-center">Branch</th>
              </tr>
              </thead>
<!--              Tbody-->
              <tbody>
              <tr
                  v-for="rank in ranks.ranking"
                  :key="rank.id"
                  v-if="!(rank.id === null && rank.is_consultant === undefined)"
                  :class="[
                    {
                      'top-five': rank.badge !== null && !rank.is_consultant,
                      'managed-consultant': isMarked(rank.id),
                      'child-row': rank.is_consultant
                    },
                    rank.is_consultant ? 'consultant-of-' + rank.managed_by : ''
                  ]"
                  v-show="!rank.is_consultant || expandedRows.includes(rank.managed_by)"
              >
                <td class="text-center">
                  <strong v-if="!rank.is_consultant">{{ rank.rank }}</strong>
                </td>

                <td v-if="rank.is_consultant !== undefined || rank.is_manager" class="expand-button text-center">
                  <span v-if="dashboardType === 'team_manager' && hasConsultants(rank.id) && !rank.is_consultant"
                        @click="toggleConsultants(rank.id)"
                        style="cursor: pointer;"
                  >
                    <i class="text-success fa" :class="expandedRows.includes(rank.id) ? 'fa-minus-square' : 'fa-plus-square'"></i>
                  </span>
                </td>
                <td v-else class="d-none"></td>

                <td class="rank-badge text-center">
                  <img
                      v-if="rank.badge && !rank.is_consultant"
                      :src="`/images/icons-rank/${rank.badge}.svg`"
                      class="img-xs"
                      :alt="rank.name"
                  />
                  <span v-else></span>
                </td>

                <td class="rank-consultant text-center">
                  <div class="rank-badge text-center">
                    <img
                        v-if="rank.badge && rank.is_consultant"
                        :src="`/images/icons-rank/${rank.badge}.svg`"
                        class="img-xs"
                        :alt="rank.name"
                    />
                  </div>
                  <img v-if="rank.image" :src="`${rank.image}`" class="img-circle mr-2" :alt="`${rank.name}`" />
                  <div v-else class="img-circle mr-2 p-2"><i class="fas fa-robot fa-lg"></i></div>
                  <strong>{{ rank.name }}</strong>
                </td>

                <td class="text-center">
                  <strong v-if="rank.total_points && !rank.is_consultant">{{rank.total_points}}</strong>
                  <strong v-else>{{ rank.points }}</strong>
                </td>

                <td class="text-center">
                  <div v-if="!rank.is_consultant">{{ rank.branch }}</div>
                </td>
              </tr>
              </tbody>
              <tfoot>
              <tr>
                <th></th>
                <th class="expand-column" v-if="dashboardType === 'team_manager'"></th>
                <th v-else class="d-none"></th>
                <th></th>
                <th>Total Points</th>
                <th>{{ ranks.totals }}</th>
                <th></th>
              </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import '../../../sass/sales-rank.scss'
import {formatPeriod} from "../../utils/helpers";

export default {
  name: 'RankByLevelPoints',
  props: {
    dashboardType: {
      type: String,
      default: 'consultant',
      validator: (value) => ['team_manager', 'consultant'].includes(value)
    }
  },
  computed: {
    headline() {
      return this.dashboardType === "team_manager" ? "Leader" : "Guide";
    },
    markedUsers() {
      const ids = [];
      this.ranks.ranking.forEach(rank => {
        if (rank.marker.is_logged_in_user || rank.marker.is_same_branch) {
          ids.push(rank.id);
        }
      });

      return ids;
    },
    consultantsByManager() {
      const consultants = {};
      this.consultantRanks.ranking.forEach(consultant => {
        if (!consultants[consultant.managed_by]) {
          consultants[consultant.managed_by] = [];
        }
        consultants[consultant.managed_by].push(consultant);
      });
      return consultants;
    }
  },
  methods: {
    formattedPeriod(month, year, mode = false) {
      return formatPeriod(month, year, mode);
    },
    getPeriod(periodType = 'current') {
      let month = this.currentMonth;
      let year = this.currentYear;

      if (periodType === 'previous') {
        month = month - 1

        if (month < 1) {
          month = 12
          year -= 1
        }
      } else if (periodType === 'next') {
        month = month + 1

        if (month > 12) {
          month = 1
          year += 1
        }
      }

      return {
        month: month,
        year: year,
      }
    },
    async fetchRank(periodType = 'current', show = true) {
      if (show) {
        this.isLoading = true
        this.expandedRows = [];

        try {
          const monthAndYear = this.getPeriod(periodType)

          const payload = {
            type: this.dashboardType,
            month: monthAndYear.month,
            year: monthAndYear.year
          }

          const response = await this.getRank(payload)

          if (response.status === 200) {
            this.ranks = response.data
            this.currentMonth = monthAndYear.month
            this.currentYear = monthAndYear.year
            if (this.dashboardType === "team_manager") {
              const consultantPayload = {
                type: 'consultant',
                month: monthAndYear.month,
                year: monthAndYear.year
              }
              const consultantResponse = await this.getRank(consultantPayload)
              if (consultantResponse.status === 200) {
                this.consultantRanks = consultantResponse.data
                this.$nextTick(() => {
                  this.insertConsultants();
                });
              }
            }
          }
        } catch (error) {
          console.error(`Error Fetching ${this.headline} Level Points Rank: `, error);
        } finally {
          this.isLoading = false;
        }
      }
    },
    async getRank(params) {
      const api = axios.create({
        baseURL: '/admin/user-rank/'
      })

      return api.get('level-points', {params})
    },
    isMarked(userId) {
      return this.markedUsers.includes(userId);
    },
    insertConsultants() {
      if (!this.ranks.ranking.length || !this.consultantRanks.ranking.length) {
        console.warn("Ranks or Consultant Ranks are empty. Skipping insertConsultants.");
        return;
      }

      const rankMap = new Map();
      this.ranks.ranking.forEach(rank => {
        rankMap.set(rank.id, {...rank, consultants: []});
      });

      this.consultantRanks.ranking.forEach(consultant => {
        if (rankMap.has(consultant.managed_by)) {
          consultant.is_consultant = true; // Flag for styling
          rankMap.get(consultant.managed_by).consultants.push(consultant);
        }
      });

      const updatedRanks = [];
      this.ranks.ranking.forEach(rank => {
        updatedRanks.push(rank);
        const placeholder = {
          ...rank,
          id: null,
          is_consultant: true,
          points: rank.points || 0,
        };

        if (rankMap.get(rank.id)?.consultants.length) {
          // Collect consultants + placeholder and sort together
          const sortedConsultants = [...rankMap.get(rank.id).consultants, placeholder].sort((a, b) => {
            if ((b.points || 0) !== (a.points || 0)) {
              return (b.points || 0) - (a.points || 0); // Sort by points DESC
            }
            return a.id === null ? -1 : 1; // Ensure placeholder appears first if points are equal
          });

          updatedRanks.push(...sortedConsultants);
        } else {
          updatedRanks.push(placeholder);
        }
      });

      this.ranks.ranking = updatedRanks;
    },
    toggleConsultants(managerId) {
      if (this.expandedRows.includes(managerId)) {
        this.expandedRows = this.expandedRows.filter(id => id !== managerId);
      } else {
        this.expandedRows.push(managerId);
      }
    },
    hasConsultants(managerId) {
      return this.consultantsByManager[managerId]?.length > 0;
    }
  },
  data() {
    return {
      isLoading: false,
      currentMonth: new Date().getMonth() + 1,
      currentYear: new Date().getFullYear(),
      ranks: {
        ranking: [],
        totals: 0,
        show_previous_month_button: false,
        show_next_month_button: false
      },
      consultantRanks: {
        ranking: [],
        totals: 0,
        show_previous_month_button: false,
        show_next_month_button: false
      },
      expandedRows: []
    }
  },
  mounted() {
    this.fetchRank()
  },
}
</script>